import React from 'react';
import { createContext, useState } from "react";
import { NOTIFICACION_ESTADO as estado} from '../consts/notificacionEstado';

const NotificacionContext = createContext()

const NotificacionProvider = ({children}) => {

    const [mensajes, setMensajes ] = useState([]);

    const [countNotificacionesNoLeidas, setCountNotificacionesNoLeidas] = useState(0)

    const marcarNotificacionesLeidas = () =>{
        const lista = mensajes.map((item) => {
            return {
              ...item,
              estado: estado.LEIDO
        }   
        });
        
        setMensajes(lista);    
    }   

    const data = {
        countNotificacionesNoLeidas,
        setCountNotificacionesNoLeidas,
        mensajes,
        setMensajes,
        marcarNotificacionesLeidas
    }

    return(
        <NotificacionContext.Provider value={data}>
            {children}
        </NotificacionContext.Provider>
    )
}

export default NotificacionProvider

export { NotificacionContext }